export  class PayInfo {

  vs: string;
  startFee;
  note: string;
  name: string;
  account;

}
